/* eslint-disable */
import {Service} from 'components/Shared/server';
import {IMenuItem} from 'models/IMenuItem';
import {NavigationBlock} from 'models/NavigationBlock';


export const routeGetMainMenu = () => `/api/appshell/mainmenu`;
export function getMainMenu(): Promise<IMenuItem[]> {
  return Service.get<IMenuItem[]>({
    url: routeGetMainMenu()
  });
}

export const routeGetBrandsMenu = () => `/api/appshell/menu/brands`;
export function getBrandsMenu(): Promise<NavigationBlock> {
  return Service.get<NavigationBlock>({
    url: routeGetBrandsMenu()
  });
}
